import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { blue, red, textMuted, white } from '@/theme/colors'
import { shadows, radii } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export const Card = styled.div`
	background-color: ${white};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.inner};
	padding: 24px;
	display: flex;
	flex-direction: column;
	min-width: 0;
`

export const Head = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	margin-bottom: 16px;
`

export const Count = styled.span`
	font-size: ${fontSizes.heroSm};
	font-weight: 700;
	color: ${blue};
	line-height: ${leading.none};
`

export const Label = styled.span`
	font-size: ${fontSizes.base};
	font-weight: 500;
	color: ${textMuted};
`

export const List = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`

export const RowLink = styled(Link)<{ $deleted?: boolean }>`
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: 12px;
	padding: 8px 6px;
	border-bottom: 1px solid ${textMuted}14;
	text-decoration: none;
	background-color: ${({ $deleted }) => ($deleted ? `${red}0d` : 'transparent')};
	border-radius: ${radii.small};

	&:hover {
		background-color: ${blue}0d;
	}
`

export const RowText = styled.div`
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
`

export const RowPrimary = styled.span`
	color: ${blue};
	font-weight: 700;
	font-size: ${fontSizes.base};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const RowSecondary = styled.span`
	color: ${textMuted};
	font-size: ${fontSizes.caption};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const RowMeta = styled.span`
	color: ${textMuted};
	font-size: ${fontSizes.caption};
	white-space: nowrap;
	flex-shrink: 0;
`

export const DeletedTag = styled.span`
	display: inline-block;
	margin-left: 6px;
	padding: 1px 6px;
	border-radius: ${radii.small};
	background-color: ${red};
	color: ${white};
	font-size: ${fontSizes.micro};
	font-weight: 700;
	vertical-align: middle;
`


export const SeeAll = styled(Link)`
	margin-top: 14px;
	align-self: flex-end;
	color: ${blue};
	font-weight: 700;
	font-size: ${fontSizes.small};
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`
